import React, { useEffect, useState } from "react";
import { useNavigate, useLocation, Outlet } from "react-router-dom";
import { Tabs, Tab, Box } from "@mui/material";
import { useSelector } from "react-redux";

const pageNo = "AccountPage";

function AccountPage() {
  const navigate = useNavigate(); // Hook để điều hướng
  const location = useLocation(); // Hook để lấy thông tin URL hiện tại
  const user = useSelector((state) => state.auth.user);
  const customerInfor = useSelector((state) => state.auth.customerInfor);
  const roles = useSelector((state) => state.auth.roles) || null;
  const [tabValue, setTabValue] = useState(0);
  const [menuItems, setMenuItems] = useState([
    {
      stt: 0,
      text: "Thông tin",
      path: "/tai-khoan/thong-tin",
      pageNo: "CustomerInforPage",
    },
    {
      stt: 2,
      text: "Người dùng",
      path: "/tai-khoan/nguoi-dung",
      pageNo: "UsersPage",
    },
    {
      stt: 3,
      text: "Vai trò",
      path: "/tai-khoan/vai-tro",
      pageNo: "RolePage",
    },
    {
      stt: 4,
      text: "KÝ HIỆU VÀ MẪU",
      path: "/tai-khoan/ky-hieu-va-mau",
      pageNo: "InvoiceSignAndTemplatePage",
    },
    {
      stt: 5,
      text: "Đăng ký hoá đơn",
      path: "/tai-khoan/dang-ky-hoa-don",
      pageNo: "InvoiceRegistrationPage",
    },
    {
      stt: 6,
      text: "Cấu hình dữ liệu",
      path: "/tai-khoan/cau-hinh-du-lieu",
      pageNo: "DataConfigPage",
    },
    {
      stt: 7,
      text: "Cấu hình tiện ích",
      path: "/tai-khoan/cau-hinh-tien-ich",
      pageNo: "WidgetConfigPage",
    },
  ]);
  useEffect(() => {
    const filtered = menuItems.filter((item) => {
      if (item.pageIsAdmin === true) {
        return (
          (customerInfor.CusIsAdmin === true &&
            roles.some(
              (x) =>
                x.PvNo === item.pageNo &&
                x.CtrNo === "viewPage" &&
                x.IsApproved === true,
            )) ||
          item.stt === 0
        );
      }
      if (item.pageIsAdmin === false) {
        return (
          (customerInfor.CusIsAdmin === false &&
            roles.some(
              (x) =>
                x.PvNo === item.pageNo &&
                x.CtrNo === "viewPage" &&
                x.IsApproved === true,
            )) ||
          item.stt === 0
        );
      }
      return (
        roles.some(
          (x) =>
            x.PvNo === item.pageNo &&
            x.CtrNo === "viewPage" &&
            x.IsApproved === true,
        ) || item.stt === 0
      );
    });

    setMenuItems(filtered);
  }, []);

  useEffect(() => {
    setTabValue(() => {
      let i = menuItems[0].stt;
      menuItems.map((item, index) => {
        if (
          location.pathname === item.path ||
          (item.path !== "/" && location.pathname.startsWith(item.path + "/"))
        )
          i = item.stt;
      });
      return i;
    });
  }, [location.pathname]);

  const handleChangeTab = (event, newValue) => {
    setTabValue(newValue);
  };

  useEffect(() => {
    if (location.pathname.endsWith("/tai-khoan"))
      navigate(menuItems[tabValue].path);
  }, [navigate, menuItems, tabValue]);

  return (
    <Box
      sx={{
        flexGrow: 1,
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Menu Tabs */}
      <Tabs
        value={tabValue}
        onChange={handleChangeTab}
        indicatorColor="primary"
        textColor="primary"
        selectionFollowsFocus
      >
        {menuItems.map((item, index) => {
          return (
            <Tab
              key={item.stt}
              label={item.text}
              value={item.stt}
              onClick={() => {
                navigate(item.path);
              }}
            />
          );
        })}
      </Tabs>

      <Box
        sx={{
          flexGrow: 1,
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          overflow: "auto",
        }}
      >
        {/*Route sẽ hiển thị trang con thông qua Outlet*/}
        <Outlet />
      </Box>
    </Box>
  );
}

export default AccountPage;
